import { useFormikContext } from 'formik';
import Button from 'shared/components/Button';
import FormField from 'shared/components/form/FormField';
import StyledDatePicker from 'shared/components/StyledDatePicker';
import * as Yup from 'yup';
import { EventoWizardFormValues } from './eventoWizardTypes';

export const datesFields = ['fromDate', 'toDate'] as const;

export const datesSchema = Yup.object().shape({
  fromDate: Yup.string().required('La fecha "desde" es requerida'),
  toDate: Yup.string()
    .optional()
    .test(
      'after-from',
      'La fecha "hasta" no puede ser anterior a "desde"',
      function (value) {
        const { fromDate } = this.parent;
        if (!value || !fromDate) {
          return true;
        }
        return value >= fromDate;
      }
    )
});

interface Props {
  onBack: () => void;
  onNext: () => void;
}

const EventoDatesStep = ({ onBack, onNext }: Props) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext<EventoWizardFormValues>();

  return (
    <div className="flex max-w-lg flex-col gap-5">
      <h2 className="text-xl font-semibold text-ink dark:text-ink-dark">
        Fechas
      </h2>
      <FormField label="Desde" error={touched.fromDate && errors.fromDate}>
        <StyledDatePicker
          value={values.fromDate || null}
          onChange={(value) => setFieldValue('fromDate', value ?? '')}
          onBlur={() => setFieldTouched('fromDate', true)}
        />
      </FormField>

      <FormField label="Hasta" error={touched.toDate && errors.toDate}>
        <StyledDatePicker
          value={values.toDate || null}
          onChange={(value) => setFieldValue('toDate', value ?? '')}
          onBlur={() => setFieldTouched('toDate', true)}
          minDate={values.fromDate || null}
        />
      </FormField>

      <div className="flex justify-between pt-4">
        <Button type="button" variant="secondary" onClick={onBack}>
          Atrás
        </Button>
        <Button type="button" onClick={onNext}>
          Siguiente
        </Button>
      </div>
    </div>
  );
};

export default EventoDatesStep;
